export const config = { 
    apiKey: "AIzaSyAdM70NnwVU8SotNDdFm1I9yPOuuZSR7h4",
    authDomain: "smart-af.firebaseapp.com",
    databaseURL: "https://smart-af.firebaseio.com",
    projectId: "smart-af",
    storageBucket: "smart-af.appspot.com",
    messagingSenderId: "433483297135",
    appId: "1:433483297135:web:3553639220dde043",
    measurementId: "G-JGWRQ238WY"
};